<template>
  <div class="" style="margin-top: -20px;">
    <h2 class="title white">Horários da sua consulta com</h2>
    <div v-if="error_message" class="error-panel">{{ error_message }}</div>

    <div class="prof-header">
      <img :src="$baseUrl + 'storage/' + professional.image" alt="" style="margin-top: -10px;">

      <div class="prof-data">
        <p style="font-weight: bold;">{{ professional.name }}</p>
        <p style="text-transform: lowercase;">{{ professional.specialties[0].name }}</p>
        <span>{{ professional.council.initials }}-{{ professional.council_state }} {{ professional.council_number
          }}</span>
      </div>

      <div class="btn" style="margin-top: 6px; margin-left: 20px; padding: 0 10px; font-size: 22px;"
        @click="$emit('buttonClicked', 'ProfsList')">
        <span style="text-align: center;">Trocar médico</span>
      </div>
    </div>

    <div v-show="is_loading" style="margin: 0 auto; margin-top: 100px;">
      <h2 style="width: fit-content; margin: 0 auto; color: #fff;">Agendando...</h2>
      <pulse-loader :loading="loading" :color="color" :size="size"
        style="width: fit-content; margin: 0 auto;"></pulse-loader>
    </div>

    <paginate v-show="!is_loading" name="availabityOrdered" :list="suggestions" :per="10"
      style="border: 1px solid; display: contents;" class="ui five column grid">
      <div v-for="(available, index) in paginated('availabityOrdered')" :key="index" class="column">

        <div class="option" style="text-align: center;" @click="saveTicket(available, available.appointment_return)">
          <div class="header">
            <p>{{ available.date | getMonth }}</p>
          </div>

          <div class="agreement-img">
            <img :src="available.agreement_image" alt="">
          </div>

          <p class="date">{{ available.date | getDay }}</p>

          <div class="date-day-time">
            <span style="padding-bottom: 10px;">{{ available.day }}</span>
            <span>{{ available.time }}</span>
            <span v-show="available.appointment_return == true"
              style="padding-top: 10px; font-style: italic; color: #000;">RETORNO</span>
          </div>

        </div>

      </div>
    </paginate>

    <div v-show="!is_loading" class="footer-btn">

      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>

      <div class="pagination">
        <paginate-links for="availabityOrdered" :simple="{
        prev: 'Voltar',
        next: 'Outra data'
      }"></paginate-links>

        <div class="btn" style="width: fit-content; padding: 0 20px; color: #fff; background: #3ae374;"
          @click="saveTicket()">
          <span>Decidir na recepção</span>
        </div>

      </div>

    </div>

  </div>
</template>
<script>
import moment from 'moment';
import PulseLoader from 'vue-spinner/src/PulseLoader';
import Swal from 'sweetalert2'
import swal from 'sweetalert';

export default {
  components: {
    PulseLoader
  },
  props: {
    agreement: Object,
    customer: Object,
    procedure: Object,
    professional: Object,
    returns: Array,
    schedulings: Array,
    suggestions: Array,
    ticket: Object
  },
  data() {
    return {
      // spinner
      is_loading: false,
      loading: false,
      color: '#fff',
      width: '50',
      height: '50',
      size: '20px',
      error_message: '',
      created_customer: null,
      //
      msg: 'Por favor, escolha um horário. Ou clique no botão "Decidir na recepção"',
      lang: 'pt-BR',
      //procedure: {},
      req_return: {},
      return_limit: '',
      availabity: [],
      arrPaginate: [],
      page: 1,
      limit: 10,
      countPage: 0,
      paginate: ['availabityOrdered'],
      req: {
        type: '', //0 - tipo consulta, 1 - tipo exame
        date_req: '',
        customer_id: '',
        medical_record: '',
        agreement_id: '',
        applicant_professional_id: '',
        status_agreement: '1',
      },
      proc_req: {
        requisition_id: '',
        executor_professional_id: [],
        price: [],
        procedure_id: [],
        quantity: [1],
        status: ['0'], //agendado
        type: [], //0 - tipo consulta, 1 - tipo exame
        scheduled: ['true']
      },
      scheduling: {
        status: 0,
        requisition_id: '',
        professional_id: '',
        procedure_id: '',
        exception: '0',
        obs: '',
        date_scheduling: '',
        time_starting_booked: '',
        time_end_booked: '',
      },
      scheduling_ticket_obj: {
        scheduling_id: 0,
        ticket_id: []
      }
    }
  },
  computed: {
    availabityOrdered: function () {
      return _.orderBy(this.availabity, 'date_scheduling', 'asc');
    }
  },
  filters: {
    getDay(value) {
      let day = value.split(" ")[0]
      return day
    },
    getMonth(value) {
      let month = value.split(" ")[2]
      return month
    }
  },
  mounted() {
    var app = this;
    this.checkReturnAvailable()
  },
  methods: {
    checkReturnAvailable() {
      let returnAvailable = this.suggestions.filter(elem => {
        return elem.appointment_return == true
      })
      if (returnAvailable.length > 0) {
        console.log('retorno disponivel')
        let return_limit = returnAvailable.pop()
        this.showModalReturn(return_limit.index)
      } else {
        this.speak(this.msg);
      }
    },
    showModalReturn(date) {
      let formatDate = moment(date).format('DD/MM/YYYY')
      let msg = "Você possui Retorno disponível até " + formatDate
      this.speak(msg);
      swal({
        title: '',
        text: msg,
        icon: 'warning'
      }).then(() => {
        this.speak(this.msg)
      })
    },
    showReturn(elem) {
      if (this.return_limit != '') {
        if (elem.date_scheduling < this.return_limit) {
          return true
        } else {
          return false
        };
      } else {
        return false
      };
    },
    speak(msg) {
      var app = this;
      var utterThis = new SpeechSynthesisUtterance(msg);
      var voices = speechSynthesis.getVoices();
      var voice_br = {};
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      window.speechSynthesis.speak(utterThis);
    },
    falar() {
      let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
      let recognition = SpeechRecognition ? new SpeechRecognition() : false
      recognition.lang = this.lang;
      recognition.interimResults = true;
    },
    setAvailabity() {
      var app = this;
      // permite agendar ou não com tempo excedido
      var exceed_schedule = false;
      var prof_duration = moment.duration(this.professional.appointment_duration);
      let newArr = [];
      var today = moment().format('YYYY-MM-DD');
      var now = moment().format('HH:mm:ss');

      setTimeout(function () {
        app.schedulings.map((value, i) => {
          var time_start = moment.duration(value.time_end_booked);
          var date = moment(value.date_scheduling).locale('pt');
          var hora = value.time_end_booked.substring(0, 5);

          var obj = {
            mes: '',
            dia: '',
            dia_semana: '',
            horario: '',
            date_scheduling: value.date_scheduling.substring(0, 10),
            time_end_booked: value.time_end_booked
          };

          if (value.date_scheduling.substring(0, 10) == today) {
            if (value.time_end_booked < now) {
              obj.time_end_booked = moment.utc((moment.duration(now).add(moment.duration('00:05'))).asMilliseconds()).format("HH:mm:ss")
              obj.horario = moment.utc((moment.duration(now).add(moment.duration('00:05'))).asMilliseconds()).format("HH:mm");
            } else {
              obj.horario = hora;
            }
          } else {
            obj.horario = hora;
          }

          if (!exceed_schedule) {

          };

          obj.mes = date.format('MMMM');
          obj.dia = date.format('DD');
          obj.dia_semana = date.format('dddd');
          if (newArr.length != 20) {
            newArr.push(obj);
          };
          app.availabity = newArr;
        });
        app.countPage = Math.ceil(app.availabity.length / app.limit);
      }, 1000);
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
      else
        byteString = unescape(dataURI.split(',')[1]);
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      };
      return new Blob([ia], { type: mimeString });
    },
    saveScheduling(obj) {
      console.log(obj);
      let req = this.req;
      let procReq = this.proc_req;
      // Gravando requisição
      if (this.ticket.attendance_type_id == 1) {
        req.type = 0
      } else if (this.ticket.attendance_type_id == 2) {
        req.type = 2
      };

      req.agreement_id = obj.agreement_id;
      req.applicant_professional_id = this.professional.id;
      if (this.customer.id != 0) {
        req.customer_id = this.customer.id;
        req.medical_record = this.customer.medical_record;
      };
      req.date_req = moment().format('Y-MM-DD HH:mm:ss');
      axios.post('api/kiosk/requisition', req)
        .then(({ data }) => {
          console.log('requisição gravada');

          // Gravando agendamento
          let schedule = this.scheduling;
          var proc_duration_hour = this.professional.appointment_duration.substring(0, 2);
          var proc_duration_min = this.professional.appointment_duration.substring(3, 5);
          var next_time = moment(obj.time_end_booked).add(proc_duration_hour, "hours").add(proc_duration_min, "minutes").format("HH:mm:ss");

          schedule.requisition_id = data.data.id;
          schedule.professional_id = this.professional.id;
          schedule.procedure_id = this.procedure.id;
          schedule.date_scheduling = obj.date_scheduling;
          schedule.authorized_checkin = false;
          schedule.time_starting_booked = obj.time_end_booked;
          schedule.time_end_booked = next_time;
          schedule.date_checkin = moment().format('Y-MM-DD HH:mm:ss');
          schedule.pendency = true

          axios.post('api/kiosk/scheduling', schedule)
            .then(({ data }) => {
              console.log('agendamento gravado');
            }).catch((err) => {
              console.log('erro ao gravar agendamento', err);
            });

          // Gravando procedure_requisition
          procReq.requisition_id = data.data.id;
          procReq.executor_professional_id.push(this.professional.id);

          let procPrice = parseFloat(this.procedure.pivot.price);

          procReq.procedure_id.push(this.procedure.id);
          procReq.price.push(procPrice);
          procReq.type.push('0');

          axios.post('api/kiosk/procedureRequisition', procReq)
            .then(({ data }) => {
              console.log('proc_req gravada');
            }).catch((err) => {
              console.log('erro ao gravar proc_req', err);
            });
        }).catch((err) => {
          console.log('erro ao gravar requisição', err);
        });

      this.$emit('buttonClicked', 'FinishTicket');

    },
    async createCustomer() {
      if (this.created_customer) return this.created_customer;
      if (!this.ticket.photo) throw new Error('Foto do paciente não encontrada');
      const formDataCustomer = new FormData();
      formDataCustomer.append('image', this.dataURItoBlob(this.ticket.photo));
      formDataCustomer.set('name', this.customer.name);
      formDataCustomer.set('agreement_id', this.agreement.id);
      formDataCustomer.set('second_id', 0);
      const { data } = await axios.post('api/kiosk/customer', formDataCustomer, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      this.created_customer = data.data;
      return this.created_customer;
    },
    async saveTicket(horario, is_return) {
      if (this.is_loading) return;
      this.is_loading = true;
      this.loading = true;
      this.error_message = '';
      try {
        const customer = this.customer.id == 0 ? await this.createCustomer() : this.customer;
        if (horario != null) {
          await axios.post('api/kiosk/requisitions/totem', {
            agreement_id: horario.agreement_id,
            applicant_professional_id: this.professional.id,
            date_scheduling: horario.index,
            time: horario.time,
            weight: this.ticket.weight,
            status_agreement: is_return ? (this.agreement.pay_cash ? '6' : '0') : '1',
            type: is_return ? '1' : '0',
            customer_id: customer.id
          });
        } else {
          const ticketObj = Object.assign({}, this.ticket, {
            started_at: moment().format('YYYY-MM-DD HH:mm:ss'),
            customer_id: customer.id,
            name: customer.name,
            photo: customer.image,
            agreement_id: this.agreement.id
          });
          await axios.post('api/kiosk/ticket', ticketObj);
        }
        this.$emit('buttonClicked', 'FinishTicket');
      } catch (err) {
        this.is_loading = false;
        this.loading = false;
        this.error_message = 'Não foi possível concluir o agendamento. Verifique a conexão e tente novamente.';
      }
    }
  }
}
</script>
<style scoped>
.prof-header {
  display: flex;
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 20px;
}

.prof-header img {
  margin-top: -10px;
  width: 90px;
  height: 90px;
  border-radius: 500px;
}

.prof-header .prof-data {
  text-align: left;
  font-size: 20px;
  padding: 6px 10px 0px 10px;
  color: #fff;
}

.prof-header .prof-data p {
  margin-top: -7px;
  margin-bottom: 0px;
}

.agreement-header {
  display: -webkit-inline-box;
}

.agreement-header h2 {
  font-size: 32px;
  line-height: 90px;
  padding-right: 20px;
}

.agreement-header h3 {
  font-size: 28px;
  font-weight: bold;
  margin-right: 10px;
  padding-top: 20px;
}

.agreement-header img {
  width: 90px;
  height: 90px;
  border-radius: 500px;
}

.agreement-img {
  position: relative;
}

.agreement-img img {
  position: absolute;
  top: -40px;
  right: -36px;
  width: 80px;
  height: 80px;
  background: #fff;
  border: 1px solid #56ccf2;
  border-radius: 500px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
}

h2 {
  font-size: 32px;
  font-weight: bold;
  font-family: 'Source Sans Light';
}

.option {
  width: 220px;
  height: 260px;
  margin: 0 auto;
  padding-top: 10px;
  background: #56ccf2;
  border-radius: 20px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}

.option .header {
  margin-top: -11px;
  padding: 8px;
  background: #fff;
  font-size: 32px;
  text-transform: uppercase;
  font-family: 'Source Sans Light';
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
}

.option p.date {
  margin: 0 0 0 -14px;
  line-height: 108px;
  font-size: 120px;
  font-style: italic;
  font-family: 'Source Sans Light';
}

.option span {
  color: #fff;
  font-size: 26px;
  font-family: 'Source Sans ExtraLight';
  font-weight: bold;
}

.option .date-day-time {
  display: grid;
}

.footer-btn {
  position: fixed;
  width: 100%;
  display: flex;
  bottom: 16px;
  padding: 0px 20px;
}

.btn {
  display: flex;
  width: 180px;
  height: 60px;
  align-items: center;
  font-size: 26px;
  border-radius: 500px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}

.btn span {
  width: inherit;
}

.pagination {
  /* position: absolute; */
  display: flex;
  width: fit-content;
  right: 40px;
}

.pagination .btn {
  margin: 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfAvailability.vue